//#region src/js/predictive.js
var PredictiveSearch = class extends SearchForm {
	constructor() {
		super();
		this.cachedResults = {};
		this.abortController = new AbortController();
		this.searchTerm = "";
	}
	connectedCallback() {
		super.connectedCallback();
		if (!this.input?.form || this.listenersInitialized) return;
		this.listenersInitialized = true;
		this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
		this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
		this.setupEventListeners();
	}
	setupEventListeners() {
		this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
		this.input.addEventListener("focus", this.onFocus.bind(this));
	}
	getQuery() {
		return this.input.value.trim();
	}
	onChange() {
		super.onChange();
		const newSearchTerm = this.getQuery();
		if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
		this.updateSearchForTerm(this.searchTerm, newSearchTerm);
		this.searchTerm = newSearchTerm;
		if (!this.searchTerm.length) return;
		this.getSearchResults(this.searchTerm);
	}
	onFormSubmit(event) {
		if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) event.preventDefault();
	}
	onFormReset(event) {
		super.onFormReset(event);
		if (super.shouldResetForm()) {
			this.searchTerm = "";
			this.abortController.abort();
			this.abortController = new AbortController();
			this.closeResults(true);
		}
	}
	onFocus() {
		const currentSearchTerm = this.getQuery();
		if (!currentSearchTerm.length) return;
		if (this.searchTerm !== currentSearchTerm) this.onChange();
		else this.getSearchResults(this.searchTerm);
	}
	updateSearchForTerm(previousTerm, newTerm) {
		const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");
		const currentButtonText = searchForTextElement?.innerText;
		if (currentButtonText) {
			if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) return;
			searchForTextElement.innerText = currentButtonText.replace(previousTerm, newTerm);
		}
	}
	getSearchResults(searchTerm) {
		const queryKey = searchTerm.replace(" ", "-").toLowerCase();
		this.setLiveRegionLoadingState();
		if (this.cachedResults[queryKey]) {
			this.renderSearchResults(this.cachedResults[queryKey]);
			return;
		}
		fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, { signal: this.abortController.signal }).then((response) => {
			if (!response.ok) throw new Error(response.status);
			return response.text();
		}).then((text) => {
			const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
			this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
				predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
			});
			this.renderSearchResults(resultsMarkup);
		}).catch((error) => {
			if (error?.code === 20) return;
			throw error;
		});
	}
	setLiveRegionLoadingState() {
		this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
		this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
		this.setLiveRegionText(this.loadingText);
		this.setAttribute("loading", true);
	}
	setLiveRegionText(statusText) {
		this.statusElement.setAttribute("aria-hidden", "false");
		this.statusElement.textContent = statusText;
		setTimeout(() => {
			this.statusElement.setAttribute("aria-hidden", "true");
		}, 1e3);
	}
	renderSearchResults(resultsMarkup) {
		this.predictiveSearchResults.innerHTML = resultsMarkup;
		this.setAttribute("results", true);
		this.setLiveRegionResults();
	}
	setLiveRegionResults() {
		this.removeAttribute("loading");
		this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
	}
};
customElements.define("predictive-search", PredictiveSearch);
//#endregion
